import { render, staticRenderFns } from "./video-hero.vue?vue&type=template&id=2d51262d&scoped=true&"
import script from "./video-hero.vue?vue&type=script&lang=ts&"
export * from "./video-hero.vue?vue&type=script&lang=ts&"
import style0 from "./video-hero.vue?vue&type=style&index=0&id=2d51262d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51262d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d51262d')) {
      api.createRecord('2d51262d', component.options)
    } else {
      api.reload('2d51262d', component.options)
    }
    module.hot.accept("./video-hero.vue?vue&type=template&id=2d51262d&scoped=true&", function () {
      api.rerender('2d51262d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wordpress/video-hero.vue"
export default component.exports